import { cn } from "@/utils/classes";
import { ReactNode } from "react";

/* Prop Types */
interface ToolbarItem {
  children?: ReactNode;
  className?: string;
}

/*
 * ToolbarItem component
 */
export const ToolbarItem = ({ children, className }: ToolbarItem) => {
  /* Render */
  return <div className={cn("flex flex-row gap-2 justify-center items-center", className)}>{children}</div>;
};
